/* Visitor region, resolved once per page and shared.

   Loaded by layout/theme.liquid on every page. Answers "where is this
   shopper?" from Shopify's own IP lookup (browsing_context_suggestions.json on
   the storefront origin: first party, no quota) and publishes the answer on
   <html>:

     data-wg-region="US"      ISO code, or "unknown" when the shop can't tell
     data-wg-intl             present when the shopper is outside the home
                              countries (settings.region_home_countries)

   Liquid already sets data-wg-intl when the market the shopper picked in the
   country selector is outside the home list; this script only ever adds the
   flag, never removes it. CSS keys off html[data-wg-intl] to hide anything
   that cannot ship abroad (recommendation cards, bundle tabs), so it works
   through every section re-render without JavaScript.

   Fails OPEN: no answer, a slow answer (2.5 s) or a blocked request leaves
   the page as it was rendered, so a lookup hiccup never costs a home shopper
   anything. A positive detection is cached in sessionStorage (wg_region);
   ?wg_region=CA seeds that cache for QA.

   window.WGRegion = { ready() -> Promise<iso|null>, country, intl, home };
   `wg:region` fires on document once resolved. The gift script and the
   buy-box notice consume this instead of doing their own lookup. */
(function () {
  var root = document.documentElement;
  var configEl = document.querySelector('script[data-wg-region-config]');
  var config = {};
  try {
    config = configEl ? JSON.parse(configEl.textContent) : {};
  } catch (e) {
    config = {};
  }
  var HOME = Array.isArray(config.home) && config.home.length ? config.home.filter(Boolean) : ['US'];
  var KEY = 'wg_region';
  var TIMEOUT_MS = 2500;
  var marketIntl = root.hasAttribute('data-wg-intl');
  var pending = null;

  function cachedCountry() {
    try {
      var seed = new URLSearchParams(window.location.search).get('wg_region');
      if (seed && /^[A-Za-z]{2}$/.test(seed.trim())) sessionStorage.setItem(KEY, seed.trim().toUpperCase());
      var iso = sessionStorage.getItem(KEY);
      return iso && /^[A-Z]{2}$/.test(iso) ? iso : null;
    } catch (e) {
      return null;
    }
  }

  function detectCountry() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var lookup = fetch(base + 'browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        var handle = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        return typeof handle === 'string' && /^[A-Za-z]{2}$/.test(handle.trim()) ? handle.trim().toUpperCase() : null;
      })
      .catch(function () {
        return null;
      });
    var timeout = new Promise(function (resolve) {
      setTimeout(function () {
        resolve(null);
      }, TIMEOUT_MS);
    });
    return Promise.race([lookup, timeout]);
  }

  function apply(iso) {
    var intl = marketIntl || (iso ? HOME.indexOf(iso) === -1 : false);
    root.setAttribute('data-wg-region', iso || 'unknown');
    if (intl) root.setAttribute('data-wg-intl', '');
    api.country = iso;
    api.intl = intl;
    document.dispatchEvent(new CustomEvent('wg:region', { detail: { country: iso, intl: intl } }));
    return iso;
  }

  function ready() {
    if (pending) return pending;
    var known = cachedCountry();
    var source = known
      ? Promise.resolve(known)
      : detectCountry().then(function (iso) {
          if (iso) {
            try {
              sessionStorage.setItem(KEY, iso);
            } catch (e) {
              /* private mode */
            }
          }
          return iso;
        });
    pending = source.then(apply);
    return pending;
  }

  var api = { ready: ready, country: undefined, intl: undefined, home: HOME };
  window.WGRegion = api;
  ready();
})();
